import {
    triggerVirtualPageViewEvent,
    VirtualPageViewEvent
} from '@dazn/fe-events';
import { useEffect } from 'react';
import { getCountry, getLanguage } from '@dazn/lp-web/src/utils/dazn/Region';

export enum PageViewCategoryEnum {
    LandingPage = 'landingpage',
    NflLandingPage = 'nfllandingpage',
    ComparisonTablePage = 'comparisontablepage',
    AmazonLoginlandingPage = 'amazonloginlandingpage',
    DaznWorldLandingPage = 'daznworldlandingpage',
    DaznSuperSportsLandingPage = 'daznsupersportslandingpage',
    FibaCourtSideLandingPage = 'fibacourtsidelandingpage',
    OfertaMotor24 = 'ofertamotor24page',
    pgatourlandingpage = 'pgatourlandingpage',
    rallytv = 'rallytvlandingpage',
    CanalPlusLandingPage = 'canalpluslandingpage',
    AmazonLandingPage = 'amazonloginlandingpage',
}

function checkIsPartnerLandingPage() {
    const knownPartners = ['canal-plus', 'amazon', 'nfl', 'dazn-world', 'dazn-super-sports', 'fiba-court-side', 'oferta-motor-24', 'pgatour', 'rallytv'];
    const partner = knownPartners.find(partner => window.location.href.includes(partner));
    return partner;
}

function getPartnerCategory(partnerName: string) {
    switch (partnerName) {
        case 'canal-plus':
            return PageViewCategoryEnum.CanalPlusLandingPage;
        case 'amazon':
            return PageViewCategoryEnum.AmazonLandingPage;
        case 'nfl':
            return PageViewCategoryEnum.NflLandingPage;
        case 'dazn-world':
            return PageViewCategoryEnum.DaznWorldLandingPage;
        case 'dazn-super-sports':
            return PageViewCategoryEnum.DaznSuperSportsLandingPage;
        case 'fiba-court-side':
            return PageViewCategoryEnum.FibaCourtSideLandingPage;
        case 'oferta-motor-24':
            return PageViewCategoryEnum.OfertaMotor24;
        case 'pgatour':
            return PageViewCategoryEnum.pgatourlandingpage;
        case 'rallytv':
            return PageViewCategoryEnum.rallytv;
        default:
            return PageViewCategoryEnum.LandingPage;
    }
}

export const usePageViewTracking = (category: PageViewCategoryEnum): void => {
    const partnerName = checkIsPartnerLandingPage();

    useEffect(() => {
        let eventCategory = category;

        if (partnerName) {
            eventCategory = getPartnerCategory(partnerName);
        }

        const event: VirtualPageViewEvent = {
            page: {
                category: eventCategory,
                title: document.title,
                url: window.location.href,
                path: window.location.pathname,
                type: '',
                country: getCountry().toLocaleLowerCase(),
                language: getLanguage()
            }
        };
        triggerVirtualPageViewEvent(event);
    }, [category]);
};
